import { AsyncSelect, SelectOption } from '@cimplico/components';
import { useMemo, useState } from 'react';
import { useWorksheets } from '../../queries/use-worksheets';
import { Worksheet, WorksheetTypeEnum } from '../../types/worksheet';

type WorksheetOtherScheduleSelectProps = {
    title?: string;
    isOptional?: boolean;
    isMulti?: boolean;
    placeholder?: string;
    form?: string;
    errorMessage?: string;
    selectedIds?: string[];
    disabledIds?: string[];
    type?: WorksheetTypeEnum;
    onChange: (worksheets: Worksheet[]) => void;
};

function WorksheetOtherScheduleSelect({
    title,
    isOptional,
    isMulti,
    placeholder,
    form,
    errorMessage,
    selectedIds,
    disabledIds,
    type,
    onChange,
}: WorksheetOtherScheduleSelectProps): JSX.Element {
    const [search, setSearch] = useState<string>('');
    const worksheetQuery = useWorksheets({
        page: 1,
        searchQuery: search,
        filterQuery: type ? `type=${type}` : '',
        sortQuery: 'sort[dir]=asc&sort[field]=code',
    });

    const worksheetOptions = useMemo(() => {
        return (
            worksheetQuery?.data?.worksheets.map((w) => ({
                label: `${w.name}`,
                value: w.id,
                isDisabled: disabledIds?.includes(w.id),
                isSelected: selectedIds?.includes(w.id),
            })) || []
        );
    }, [disabledIds, selectedIds, worksheetQuery?.data?.worksheets]);

    function handleSelect(options: SelectOption[]): void {
        const worksheets =
            worksheetQuery.data?.worksheets?.filter((w) => {
                return options.find((value) => value.value === w.id);
            }) ?? [];

        onChange(worksheets);
    }

    return (
        <AsyncSelect
            placeholder={placeholder || 'Select worksheets and other schedules...'}
            title={title}
            form={form}
            isOptional={isOptional}
            isMulti={isMulti}
            isLoading={worksheetQuery.isFetching || worksheetQuery.isLoading}
            options={[...worksheetOptions]}
            errorMessage={errorMessage}
            onSearch={setSearch}
            onChange={handleSelect}
        />
    );
}
export default WorksheetOtherScheduleSelect;
